/*  iceberg-ui  */
import { Box, Button } from '@auviknetworks/iceberg-ui';

/*  Woekato  */
import { WorkatoConnectionsModal } from 'application/Home/Admin/Workato/WorkatoConnectionsModal';
import { getWorkatoStatus } from 'application/Home/Admin/Workato/functions';
import {
    WorkatoConnection,
    WorkatoStatus
} from 'application/Home/Admin/Workato/types';

/*  React  */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { SaasOpsIsConnectedChip } from '../../Client/SaasOps/SaasOpsIsConnectedChip';
import { ObjectPicker } from '../../Pickers';

const defaultOnSuccess = () => {};

/**
 * Component that displays the connection state for SaasOps integrations
 * @param name - Display name of the integration
 * @param onSuccessFn - Callback function to execute after successful connection
 * @param workatoConnection - Workato connection object containing connection details
 * @param workatoProvider - Provider name for Workato integration
 * @returns JSX element showing connection state and configuration options
 */
export const SaasOpsState = ({
    name,
    onSuccessFn,
    workatoConnection,
    workatoProvider
}: {
    name: string;
    onSuccessFn: () => void;
    workatoConnection: WorkatoConnection;
    workatoProvider: string;
}) => {
    const { t } = useTranslation();
    const { clientId } = useParams();
    const [openModal, setOpenModal] = useState(false);
    const workatoStatus = getWorkatoStatus(workatoConnection);

    const onSuccess = onSuccessFn || defaultOnSuccess;

    const visualPayload = (
        <SaasOpsIsConnectedChip isConnected lostConnection={false} />
    );

    const statuses = [
        {
            display: t('SaasOps.state.integrated'),
            displayVisualOnly: visualPayload,
            id: 'integrated'
        }
    ];

    return (
        <>
            {workatoStatus !== WorkatoStatus.connected && (
                <Box>
                    <Button
                        size="compact"
                        data-trackid="workatoConfigureButton"
                        onClick={() => setOpenModal(true)}
                    >
                        {t('Common.configure')}
                    </Button>
                </Box>
            )}
            {workatoStatus === WorkatoStatus.connected && (
                <ObjectPicker
                    disableClearable
                    title={t('SaasOps.integrationStatus')}
                    objectPayload={statuses}
                    objectNameField="display"
                    objectNameFieldVisualOnly="displayVisualOnly"
                    value="integrated"
                    visualOnly
                />
            )}
            {openModal && (
                <WorkatoConnectionsModal
                    clientId={clientId}
                    workatoProvider={workatoProvider}
                    displayName={name}
                    setOpenModal={setOpenModal}
                    onSuccessFn={() => {
                        setOpenModal(false);
                        onSuccess();
                    }}
                />
            )}
        </>
    );
};
